module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_3016.3eb457d0.png";